export default __webpack_public_path__ + "static/media/gallery-wip-prepaint-assembly_00.4e96abc4.jpg";